import type { HeldCredit } from "@studiolite/booking";
import { api } from "./api";

// Reservations du widget. Memes corps que le site du studio
// (studios/[slug]/_lib/booking-api.ts) ; le serveur revalide et recalcule tout.

/** Depenser un credit d'un pass ou d'un abonnement deja achete. */
export function bookWithCredit(classSessionId: string, credit: HeldCredit) {
  return api("/api/widget/bookings", {
    method: "POST",
    body: JSON.stringify({
      classSessionId,
      bookingMethod: "USER_PASS",
      paymentMethod: "PASS",
      subscriptionId: credit.id,
      pricingItemType: credit.kind,
      participants: [],
    }),
  }) as Promise<{ bookingId: string; status: string }>;
}
